import React from 'react'
import { Field, ErrorMessage, getIn } from 'formik'
import ErrorPopUp from '../_components/Shared/ErrorPopUp'
import ClassSelect from '../_components/Shared/ClassSelect'
import UnionSelect from '../_components/Shared/UnionSelect'
import DatePicker from '../_components/Shared/DatePicker'
import GenderSelect from '../_components/Shared/GenderSelect'
import RegionSelect from '../_components/Shared/RegionSelect'
import PicUploaderLiner from '../_components/Shared/PicUploaderLiner'
import Modal from 'react-responsive-modal'
import NumberFormat from 'react-number-format'
// import moment from 'moment';
import ReCAPTCHA from 'react-google-recaptcha'
import { AiOutlineLoading } from 'react-icons/ai'

export default ({
  touched,
  errors,
  setFieldValue,
  values,
  handleBlur,
  setFieldTouched,
  handleGetInfoByNationalCode,
  preRegisterLoading,
  isSubmitting
}) => (
  <div className="row">
    <div className={preRegisterLoading ? 'form-inline blur' : 'form-inline'}>
      <div className="col-md-2">
        <label>اتحادیه</label>
      </div>
      <div className="col-md-10 rtl">
        <UnionSelect
          disabled={isSubmitting}
          required
          defaultValue={values.unionId}
          onChange={(val, creditPayment) => {
            // console.log(val);

            setFieldValue('creditPayment', creditPayment)
            setFieldValue('unionId', val)
            setFieldValue('classId', undefined)
            setFieldValue('amount', undefined)
          }}
        />
        <ErrorMessage component={ErrorPopUp} name="unionId" />
      </div>

      <div className="clearfix" />

      <div className="col-md-2">
        <label>تقویم کلاس</label>
      </div>
      <div className="col-md-10 rtl">
        <ClassSelect
          unionId={values.unionId}
          disabled={isSubmitting || !values.unionId}
          required
          defaultValue={values.classId}
          onChange={(id, amount) => {
            setFieldValue('classId', id)
            setFieldValue('amount', amount)
          }}
        />
        <ErrorMessage component={ErrorPopUp} name="classId" />
      </div>

      <div className="clearfix" />

      <div className="col-md-2">
        <label style={{ lineHeight: 'unset' }}>
          تصویر پرسنلی
          <br />
          <span style={{ color: '#d8848e', fontSize: '11px', paddingLeft: 15 }}>
            ابعاد 3 * 4
          </span>
        </label>
      </div>
      <div className="col-md-4">
        <PicUploaderLiner
          label="انتخاب فایل تصویر پرسنلی"
          disabled={isSubmitting}
          value={values.imagePath}
          onChange={val => {
            // console.log(val);
            setFieldValue('imagePath', val)
          }}
        />
        {getIn(errors, 'imagePath') && getIn(touched, 'imagePath') ? (
          <div className={'required_validator visible'}>
            <div className="validator_container">
              <span>{errors.imagePath}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="col-md-2">
        <label>جنسیت</label>
      </div>
      <div className="col-md-4 rtl">
        <GenderSelect
          disabled={isSubmitting}
          defaultValue={values.gender}
          onChange={val => {
            setFieldValue('gender', val)
          }}
        />
        {getIn(errors, 'gender') && getIn(touched, 'gender') ? (
          <div className={'required_validator visible'}>
            <div className="validator_container">
              <span>{errors.gender}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="clearfix" />

      <div className="col-md-2">
        <label>نام</label>
      </div>
      <div className="col-md-4">
        <Field
          type="text"
          disabled={isSubmitting}
          value={values.firstName}
          onBlur={handleBlur}
          name="firstName"
          touched={touched.firstName}
          className={
            getIn(errors, 'firstName') && getIn(touched, 'firstName')
              ? 'text-input has-error rtl'
              : 'text-input required rtl'
          }
        />
        {getIn(errors, 'firstName') && getIn(touched, 'firstName') ? (
          <div className={'required_validator visible'}>
            <div className="validator_container">
              <span>{errors.firstName}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="col-md-2">
        <label>نام خانوادگی</label>
      </div>
      <div className="col-md-4">
        <Field
          type="text"
          disabled={isSubmitting}
          value={values.lastName}
          onBlur={handleBlur}
          name="lastName"
          touched={touched.lastName}
          className={
            getIn(errors, 'lastName') && getIn(touched, 'lastName')
              ? 'text-input has-error rtl'
              : 'text-input required rtl'
          }
        />
        {getIn(errors, 'lastName') && getIn(touched, 'lastName') ? (
          <div className={'required_validator visible'}>
            <div className="validator_container">
              <span>{errors.lastName}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="clearfix" />

      <div className="col-md-2">
        <label>کد ملی</label>
      </div>
      <div className="col-md-4">
        <NumberFormat
          format="##########"
          isNumericString
          allowNegative={false}
          disabled={isSubmitting}
          name="nationalCode"
          onChange={e => {
            setFieldValue('nationalCode', e.target.value)
          }}
          onBlur={handleBlur}
          value={values.nationalCode}
          className={
            errors.nationalCode && touched.nationalCode
              ? 'text-input numberFa rtl has-error'
              : 'text-input numberFa rtl required'
          }
        />

        {getIn(errors, 'nationalCode') && getIn(touched, 'nationalCode') ? (
          <div className={'required_validator visible shake'}>
            <div className="validator_container">
              <span>{errors.nationalCode}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="col-md-1" style={{ paddingRight: 0 }}>
        <button
          className="preRegisterBtn"
          disabled={isSubmitting}
          onMouseEnter={() => {
            setFieldTouched('nationalCode')
          }}
          onClick={e => {
            e.preventDefault()
            handleGetInfoByNationalCode(values.nationalCode)
          }}
          disabled={!values.nationalCode || errors.nationalCode}>
          {preRegisterLoading ? (
            <i className="mdi mdi-spin mdi-loading mdi-24px" />
          ) : (
            <span>قبلا ثبت نام کرده‌ام</span>
          )}
        </button>
      </div>

      <div className="col-md-1">
        <label>شماره شناسنامه</label>
      </div>
      <div className="col-md-4">
        <NumberFormat
          isNumericString
          allowNegative={false}
          disabled={isSubmitting}
          name="idNumber"
          onChange={e => {
            setFieldValue('idNumber', e.target.value)
          }}
          onBlur={handleBlur}
          value={values.idNumber}
          className={
            errors.idNumber && touched.idNumber
              ? 'text-input numberFa rtl has-error'
              : 'text-input numberFa rtl required'
          }
        />

        {getIn(errors, 'idNumber') && getIn(touched, 'idNumber') ? (
          <div className={'required_validator visible'}>
            <div className="validator_container">
              <span>{errors.idNumber}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="clearfix" />

      <div className="col-md-2">
        <label style={{ lineHeight: 'unset' }}>
          تصویر کارت ملی
          {/* <br /><span style={{ color: '#d8848e', fontSize: '11px', paddingLeft: 15 }}>ابعاد 3 * 4</span> */}
        </label>
      </div>
      <div className="col-md-4">
        <PicUploaderLiner
          label="انتخاب فایل تصویر کارت ملی"
          disabled={isSubmitting}
          value={values.codeMeliImagePath}
          onChange={val => {
            // console.log(val);
            setFieldValue('codeMeliImagePath', val)
          }}
        />
        {getIn(errors, 'codeMeliImagePath') &&
        getIn(touched, 'codeMeliImagePath') ? (
          <div className={'required_validator visible'}>
            <div className="validator_container">
              <span>{errors.codeMeliImagePath}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="col-md-2">
        <label>نام پدر</label>
      </div>
      <div className="col-md-4">
        <Field
          type="text"
          disabled={isSubmitting}
          value={values.fatherName}
          onBlur={handleBlur}
          name="fatherName"
          touched={touched.fatherName}
          className={
            getIn(errors, 'fatherName') && getIn(touched, 'fatherName')
              ? 'text-input has-error rtl'
              : 'text-input required rtl'
          }
        />
        {getIn(errors, 'fatherName') && getIn(touched, 'fatherName') ? (
          <div className={'required_validator visible'}>
            <div className="validator_container">
              <span>{errors.fatherName}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="clearfix" />

      <div className="col-md-2">
        <label>تاریخ تولد</label>
      </div>
      <div className="col-md-4">
        <DatePicker
          name="expireDate"
          disabled={isSubmitting}
          // maxDate={moment()}
          defaultValue={values.birthDate}
          required
          onChange={val => {
            setFieldValue('birthDate', val)
          }}
        />
        <ErrorMessage component={ErrorPopUp} name="birthDate" />
      </div>

      <div className="col-md-2">
        <label>صادره از</label>
      </div>
      <div className="col-md-4">
        <Field
          type="text"
          disabled={isSubmitting}
          value={values.birthPlace}
          onBlur={handleBlur}
          name="birthPlace"
          touched={touched.birthPlace}
          className={
            getIn(errors, 'birthPlace') && getIn(touched, 'birthPlace')
              ? 'text-input has-error rtl'
              : 'text-input required rtl'
          }
        />
        <ErrorMessage component={ErrorPopUp} name="birthPlace" />
      </div>

      <div className="clearfix" />

      <div className="col-md-2">
        <label>شماره موبایل</label>
      </div>
      <div className="col-md-4">
        <NumberFormat
          isNumericString
          allowNegative={false}
          format="###########"
          disabled={isSubmitting}
          value={values.mobile}
          name="mobile"
          onChange={e => {
            setFieldValue('mobile', e.target.value)
          }}
          onBlur={handleBlur}
          className={
            getIn(errors, 'mobile') && getIn(touched, 'mobile')
              ? 'text-input numberFa has-error rtl'
              : 'text-input numberFa required rtl'
          }
        />
        {getIn(errors, 'mobile') && getIn(touched, 'mobile') ? (
          <div className={'required_validator visible'}>
            <div className="validator_container">
              <span>{errors.mobile}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="col-md-2">
        <label>تلفن ثابت</label>
      </div>
      <div className="col-md-4">
        <Field
          type="text"
          disabled={isSubmitting}
          value={values.tels}
          onBlur={handleBlur}
          name="tels"
          touched={touched.tels}
          className={
            getIn(errors, 'tels') && getIn(touched, 'tels')
              ? 'text-input has-error rtl'
              : 'text-input required rtl'
          }
        />
        <ErrorMessage component={ErrorPopUp} name="tels" />
      </div>

      <div className="clearfix" />

      <div className="col-md-2">
        <label style={{ lineHeight: 'unset' }}>
          کد رهگیری
          <br />
          <span style={{ fontSize: '11px', paddingLeft: 2 }}>شناسه صنفی</span>
        </label>
      </div>
      <div className="col-md-4">
        <Field
          type="text"
          disabled={isSubmitting}
          value={values.senfNumber}
          onBlur={handleBlur}
          name="senfNumber"
          touched={touched.senfNumber}
          className={
            getIn(errors, 'senfNumber') && getIn(touched, 'senfNumber')
              ? 'text-input has-error rtl'
              : 'text-input required rtl'
          }
        />
        <ErrorMessage component={ErrorPopUp} name="senfNumber" />
      </div>

      <div className="col-md-2">
        <label style={{ direction: 'rtl', textAlign: 'left' }}>کد isic</label>
      </div>
      <div className="col-md-4">
        <Field
          type="text"
          disabled={isSubmitting}
          value={values.isicCode}
          onBlur={handleBlur}
          name="isicCode"
          touched={touched.isicCode}
          className={
            getIn(errors, 'isicCode') && getIn(touched, 'isicCode')
              ? 'text-input has-error rtl'
              : 'text-input required rtl'
          }
        />
        <ErrorMessage component={ErrorPopUp} name="isicCode" />
      </div>

      <div className="clearfix" />

      <div className="col-md-2">
        <label>منطقه شهرداری واحد صنفی</label>
      </div>
      <div className="col-md-4 rtl">
        <RegionSelect
          disabled={isSubmitting}
          defaultValue={values.region}
          onChange={val => {
            setFieldValue('region', val)
          }}
        />
        {getIn(errors, 'region') && getIn(touched, 'region') ? (
          <div className={'required_validator visible'}>
            <div className="validator_container">
              <span>{errors.region}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="col-md-2">
        <label>کد پستی</label>
      </div>
      <div className="col-md-4">
        <NumberFormat
          isNumericString
          allowNegative={false}
          format="##########"
          disabled={isSubmitting}
          value={values.codePosti}
          name="codePosti"
          onChange={e => {
            setFieldValue('codePosti', e.target.value)
          }}
          onBlur={handleBlur}
          className={
            getIn(errors, 'codePosti') && getIn(touched, 'codePosti')
              ? 'text-input numberFa has-error rtl'
              : 'text-input numberFa required rtl'
          }
        />
        {getIn(errors, 'codePosti') && getIn(touched, 'codePosti') ? (
          <div className={'required_validator visible'}>
            <div className="validator_container">
              <span>{errors.codePosti}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      <div className="clearfix" />

      <div className="col-md-2">
        <label style={{ direction: 'rtl', textAlign: 'left' }}>
          نشانی واحد صنفی
        </label>
      </div>
      <div className="col-md-10">
        <Field
          type="text"
          disabled={isSubmitting}
          value={values.address}
          onBlur={handleBlur}
          name="address"
          touched={touched.address}
          className={
            getIn(errors, 'address') && getIn(touched, 'address')
              ? 'text-input has-error rtl'
              : 'text-input required rtl'
          }
        />
        <ErrorMessage component={ErrorPopUp} name="address" />
      </div>

      <div className="clearfix" />

      <div className="col-md-2" />
      <div className="col-md-6 agreement" style={{ zIndex: 2 }}>
        <div className="accept ">
          <div className=" fancy">
            <input
              class="inp-cbx"
              id="cbx"
              type="checkbox"
              style={{ display: 'none' }}
              disabled={isSubmitting}
              onChange={e => {
                setFieldValue('accept', e.target.checked)
              }}
            />
            <label class="cbx" for="cbx">
              <span className="circle-accept">
                <svg>
                  <polyline points="2 8 6 12 14 2.5" />
                </svg>
              </span>
              <span>
                ﺷﺮاﯾﻂ و ﻗﻮاﻧﯿﻦ دوره آﻣﻮزش اﺻﻨﺎف را ﻣﻄﺎﻟﻌﻪ و ﺗﺎﯾﯿﺪ ﻣﯽ ﻧﻤﺎﯾﻢ.
              </span>
            </label>
          </div>
          <a
            className="showModal"
            onClick={() => {
              setFieldValue('modal', true)
            }}>
            رویت قوانین
          </a>
          <br />
          <br />
          {values.amount ? (
            <span
              className="pull-right"
              style={{ color: '#d8848e', fontSize: '14px', marginRight: 30 }}>
              <NumberFormat
                thousandSeparator={true}
                className="numberFa"
                value={values.amount}
                displayType="text"
                prefix="هزینه کلاس: "
                suffix=" ریال"
              />
            </span>
          ) : (
            ''
          )}
        </div>
        {getIn(errors, 'accept') && getIn(touched, 'accept') ? (
          <div
            className={'required_validator visible'}
            style={{ left: 'auto' }}>
            <div
              className="validator_container"
              style={{ paddingRight: 20, paddingLeft: 20 }}>
              <span>{errors.accept}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      {/* <div className="col-md-4 captcha">
        <ReCAPTCHA
          // ref={recaptchaRef}
          // sitekey="6LdAR7IUAAAAAPPz8y3B9OKFenQV81XiVAOBixgx"
          sitekey="6LeV3swUAAAAAFYTtvUdqNord4LHGMQdumehzkl1"
          onChange={() => {
            setFieldValue('captcha', true)
          }}
        />
        {getIn(errors, 'captcha') && getIn(touched, 'captcha') ? (
          <div className={'required_validator visible'}>
            <div className="validator_container">
              <span>{errors.captcha}</span>
            </div>
          </div>
        ) : (
          ''
        )}
      </div> */}
      <div className="clearfix" />

      <div className="col-md-4 col-md-offset-8 col-sm-12 col-xs-12">
        <button className="registerBtn" disabled={isSubmitting}>
          {isSubmitting ? (
            <span style={{ direction: 'ltr' }}>
              <AiOutlineLoading className="mdi-spin" size="22px" /> لطفا صبر
              کنید ...{' '}
            </span>
          ) : values.creditPayment ? (
            <span>ثبت نام و دریافت رسید</span>
          ) : (
            <span>ثبت نام و پرداخت هزینه کلاس</span>
          )}
        </button>
      </div>
      <div className="clearfix" />
    </div>

    <Modal
      open={values.modal}
      onClose={() => {
        setFieldValue('modal', false)
      }}
      center
      classNames={{
        overlay: 'customOverlay',
        modal: 'customModalHome',
        closeButton: 'customModalCloseButton'
      }}>
      <ul>
        <li> حضور در هر سه روز و در تمامی ساعات الزامی می باشد. </li>
        <li>
          {' '}
          در ابتدا و انتهای هر دوره حضور و غیاب انجام و در صورت غیبت مجدد باید
          دوره را شرکت نمایند.
        </li>
        <li>
          در صورت غیبت پس از مراجعه به اتحادیه و اخذ معرفی نامه ثبت نام مجدد به
          صورت حضوری به اتاق اصناف مراجعه و تاریخ کلاس اخذ نمایند.
        </li>
        <li>حضور به موقع و منظم در کلاسهای آموزشی الزامی می باشد.</li>
        <li>
          جهت حفظ شأن استاد و حرمت محیط آموزش، از بردن هر گونه خوراکی و آشامیدنی
          به داخل کلاسها خودداری نمایید.
        </li>
        <li>
          {' '}
          ضبط جلسات تدریس به صورت تصویری ممنوع بوده و ضبط صوتی فقط با هماهنگی
          اساتید محترم امکان پذیر می باشد. ضمناً استفاده از تلفن همراه در کلاس
          ممنوع است.
        </li>
        <li>
          پس از حضور در هر سه روز گواهی از طریق تب پنل کاربری قابل دسترسی می
          باشد.
        </li>
        <br />
        <h5>مقررات انضبـاطی:</h5>
        <li>
          چون رعایت موازین اسلامی و دفاع از ارزشهای اسلامی در راس اهداف مجموعه
          قرار دارد لذا مراعات دقیق موارد ذیل برای کلیه فراگیران الزامی می باشد.
        </li>
        <li>
          رعایت کامل حجاب اسلامی برای خواهران: مانتوی بلند (بدیهی است استفاده از
          چادر حجاب برتر اولی است) مقنعه – شلوار با رنگهای مناسب – عدم استفاده
          از لوازم آرایشی
        </li>
        <li>
          رعایت پوشش اسلامی جهت برادران:عدم استفاده از لباس های آرم دار- رنگهای
          زننده و پوششهایی که تداعی کننده فرهنگ مبتذل غرب باشد.
        </li>
        <li>رعایت موازین اخلاقی و اجتماعی در محیط آموزشی</li>
      </ul>
    </Modal>
  </div>
)
